import "./TablePopoverFilter.scss";
import { Button, Popover } from "antd";
import { DownOutlined } from "@ant-design/icons";

interface TableFilterProps {
    readonly buttonText: string;
    readonly content: React.ReactNode;
    readonly open: boolean;
    readonly setOpen: (open: boolean) => void;
}

export const TablePopoverFilter = ({ buttonText, content, open, setOpen }: TableFilterProps) => (
    <Popover
        classNames={{ root: "table-popover-filter" }}
        autoAdjustOverflow={false}
        placement="bottomLeft"
        showArrow={false}
        content={content}
        trigger="click"
        open={open}
        onOpenChange={setOpen}
    >
        <Button className="filter-by-btn">
            {buttonText} <DownOutlined />
        </Button>
    </Popover>
);
